@if (section.component === 'image') {
  <app-image-figure
    [section]="section"
    [rootColumns]="rootColumns()"
  ></app-image-figure>
} @else {
  <app-video-figure
    [section]="section"
  ></app-video-figure>
}
